const stats = [
  { value: '60%', label: '中小企業が人事制度\n未整備' },
  { value: '2倍', label: '制度ありの企業の\n売上成長率' },
  { value: '15分', label: '診断アンケートの\n所要時間' },
];

export default function StatsBar() {
  return (
    <section
      className="py-14 overflow-hidden"
      style={{
        background: '#0D2B55',
        fontFamily: "'Noto Sans JP', sans-serif",
      }}
    >
      <div className="max-w-[1080px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-0 lg:divide-x lg:divide-white/15">
          {stats.map((stat, index) => (
            <div key={index} className="relative flex flex-col items-center text-center px-8 py-4">

              {/* 数字背景エフェクト */}
              <div
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                style={{
                  width: '220px',
                  height: '220px',
                  background: 'radial-gradient(circle, rgba(45,142,255,0.18) 0%, rgba(45,142,255,0.06) 45%, transparent 70%)',
                  borderRadius: '50%',
                }}
              />

              {/* 数字周辺のリングエフェクト */}
              <div
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                style={{
                  width: '140px',
                  height: '140px',
                  border: '1px solid rgba(45,142,255,0.20)',
                  borderRadius: '50%',
                }}
              />

              {/* 数字 */}
              <div className="relative z-10 mb-4">
                {/* 数字テキスト背景グロー */}
                <div
                  className="absolute inset-0 pointer-events-none blur-xl"
                  style={{
                    background: 'rgba(45,142,255,0.35)',
                    borderRadius: '12px',
                    transform: 'scale(1.3)',
                  }}
                />
                <span
                  className="relative font-bold text-white leading-none"
                  style={{
                    fontSize: '76px',
                    letterSpacing: '-2px',
                    textShadow: '0 0 40px rgba(126,203,255,0.60), 0 0 12px rgba(45,142,255,0.50)',
                  }}
                >
                  {stat.value}
                </span>
              </div>

              {/* ラベル背景エフェクト */}
              <div className="relative z-10">
                <div
                  className="absolute inset-0 -mx-3 -my-1.5 pointer-events-none rounded-lg"
                  style={{
                    background: 'linear-gradient(135deg, rgba(45,142,255,0.12) 0%, rgba(13,43,85,0.00) 100%)',
                    border: '1px solid rgba(45,142,255,0.15)',
                  }}
                />
                <p
                  className="relative text-white/80 leading-relaxed whitespace-pre-line px-3 py-1.5"
                  style={{ fontSize: '16px' }}
                >
                  {stat.label}
                </p>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
